module.exports = __webpack_public_path__ + "static/equip-b5d99f02fb3cc73ada2cd2f2b57857c1.png";